<template>
    <div v-observe-visibility="visibilityChanged">


        <!--DELETE - Dialog-->
        <!--
                <v-dialog
                        persistent
                        v-model="deleteDialog" max-width="400px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">Delete Position</span>
                        </v-card-title>

                        <v-card-text>
                            <v-form ref="form" v-model="deleteFormValidation" lazy-validation>
                                <v-checkbox
                                        :rules="[v => !!v || 'You have to check this to continue!']"
                                        required
                                        v-model="deleteChecked" color="primary"
                                        label="Do you really want to delete this position?"></v-checkbox>
                            </v-form>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary darken-1" flat @click.native="cancelDeleteDialog()">CANCEL</v-btn>
                            <v-btn color="primary darken-1" flat @click.native="deletePosition()">
                                OK
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
        -->


        <v-layout id="table-container" row>
            <v-flex xs12 pr-4 pt-4 pl-4>
                <v-card>
                    <v-card-title>
                        Supplier Order Positions
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Search"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-card-title>

                    <v-data-table
                            :headers="headers"
                            :items="getItems"
                            :pagination.sync="pagination"
                            :total-items=total
                            class="elevation-0 offer-table"
                            :loading="loadingItems"
                            :rows-per-page-items="rowsPageItems"
                    >

                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                <span>
                                          {{ props.header.text }}
                                        </span>
                            </v-tooltip>
                        </template>
                        <template slot="items" slot-scope="props">
                            <tr @dblclick="openPositionDialog(props.item.id)">
                                <td>{{ props.item.id }}</td>
                                <td class="text-xs-left">{{
                                    props.item.suppliers_order.purchase_orders_number }}
                                </td>
                                <td class="text-xs-left">{{
                                    props.item.suppliers_offers_position.suppliers_offer.supplier.name }}
                                </td>
                                <td class="text-xs-left">{{ props.item.product.reference }}
                                </td>
                                <td class="text-xs-left">{{
                                    props.item.product.manufacturer.name }}
                                </td>
                                <td class="text-xs-left">{{ props.item.quantity }}</td>
                                <td class="text-xs-left">{{props.item.suppliers_offers_position.unit.code }}</td>
                                <td class="text-xs-right">{{props.item.unit_purchase_price |
                                    toMoney}}
                                    {{props.item.suppliers_offers_position.suppliers_offer.currency.name}}
                                </td>
                                <td class="text-xs-right">{{props.item.total_purchase_price |
                                    toMoney}}
                                    {{props.item.suppliers_offers_position.suppliers_offer.currency.name}}
                                </td>
                                <td class="text-xs-left">{{ props.item.suppliers_orders_positions_status.name }}</td>

                                <!--                        <td class="text-xs-right">

                                                            <v-icon color="red"
                                                                    class="ma-1"
                                                                    @click="deletePositionDialog(props.item)"
                                                            >
                                                                delete
                                                            </v-icon>
                                                        </td>-->
                            </tr>
                        </template>
                    </v-data-table>

                </v-card>
            </v-flex>
        </v-layout>

        <v-layout row wrap justify-end mr-5>
            <v-flex xs12 sm12 md1 pr-4 pt-4 mr-5>
                <!--             <v-btn :loading="getCreatingPurchaseOrderMessage" class="secondary white&#45;&#45;text"
                                    @click.native="createCustomerOrderConfirmation()">
                                 Create Order Confirmation
                             </v-btn>-->
            </v-flex>
        </v-layout>

        <supplierOrderPositionsDialog></supplierOrderPositionsDialog>

    </div>
</template>

<script>
    import {
        Settings,
        SupplierOrder,
        SupplierOrderPosition
    } from '../../../store/namespace-helper'
    import {numberFormatFilters} from '../../../mixins/numberFormatFilters'

    import supplierOrderPositionsDialog from './AddSupplierOrderPositionDialog'

    import _ from 'lodash'

    export default {
      mixins: [numberFormatFilters],
      name: 'supplier-order-positions',
      components: {supplierOrderPositionsDialog},
      data () {
        return {
          isVisible: false,
          hide: true,
          activeTab: 0,
          headers: [
                    {text: 'Position-ID', value: 'id'},
                    {text: 'Supplier Purchase Order', value: 'purchase_orders_number'},
                    {text: 'Selected Supplier', value: 'supplier.name', sortable: false},
                    {text: 'Reference', value: 'reference'},
                    {text: 'Manufacturer', value: 'manufacturers_id'},
                    {text: 'Quantity', value: 'quantity'},
                    {text: 'Unit', value: 'unit_id', sortable: false},
                    {text: 'Unit Purchase Price', value: 'unit_purchase_price', align: 'right'},
                    {text: 'Total Sales Price', value: 'total_purchase_price', align: 'right'},
                    {text: 'Status', value: 'suppliers_orders_positions_status_id'}
                    /*                    {text: 'Action', value: 'action', sortable: false} */
          ],
          pagination: {},
          search: '',
          total: 0,
          rowsPageItems: [{'text': 'All', 'value': -1}],
          creatingOrderConfirmation: false,
          positionData: null,
          deleteDialog: false,
          deleteChecked: false,
          deleteFormValidation: false,
          loadingItems: false
        }
      },
      mounted () {

      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab order positions visible, load data')
              this.loadItems()
            } else {

            }
          }
        },
        loadItems: function () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            id: this.selectedItem.id,
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : ''
          }
          if (this.selectedItem.id !== 0) {
            this.loadingItems = true
            this.$store.dispatch(SupplierOrderPosition.actions.loadSupplierOrderPositionsForSupplierOrder, query).then(response => {
              this.loadingItems = false
            }).catch(reason => {
              console.log(JSON.stringify(reason))
              this.loadingItems = false
            })
          }
        },
        openPositionDialog (val) {
          let item = this.getItems.find(x => x.id === val)
          if (item !== null && typeof item !== 'undefined') {
            console.log('selected Position: ' + JSON.stringify(item))
            this.$store.dispatch(SupplierOrderPosition.actions.setSelectedSupplierOrderPosition, item)
          }
          this.$store.dispatch(SupplierOrderPosition.actions.openCloseDialog)
        },
        throttledLoadItems: _.debounce(function () {
          this.loadItems()
        }, 450),
        throttledTranslate: _.debounce(function (q, target) {
          this.translate(q, target)
        }, 450),
        deletePositionDialog (item) {
          this.positionData = _.cloneDeep(item)
          this.deleteDialog = true
        }
      },
      computed: {
        getItems () {
          this.total = this.$store.getters[SupplierOrderPosition.getters.supplierOrderPositions].length
          return this.$store.getters[SupplierOrderPosition.getters.supplierOrderPositions]
        },
        selectedItem () {
          return this.$store.getters[SupplierOrder.getters.getSelectedSupplierOrder]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        confirmOrderPositionDialogState () {
          return this.$store.getters[SupplierOrderPosition.getters.getOpenDialogState]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadItems()
          },
          deep: true
        },
        confirmOrderPositionDialogState: {
          handler (val) {
            if (!val) {
              this.loadItems()
            }
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        }
      }

    }
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }


</style>


// WEBPACK FOOTER //
// src/components/SupplierOrders/SupplierOrderPositions/SupplierOrderPositions.vue